import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { I18n } from 'src/translations/i18n';
import classNames from 'classnames';
import { SELECT_ELEMENT_HEIGHT } from 'src/components/Inputs/DropDownSelector/instruments';
const useStyles = makeStyles((theme) => ({
    selectEl: {
        position: 'relative',
        height: SELECT_ELEMENT_HEIGHT,
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: theme.palette.ddSelector.item,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        cursor: 'pointer',
        userSelect: 'none',
        gap: 6,
        '&:hover': {
            background: theme.palette.ddSelector.itemHover
        }
    },
    selectedEl: {
        color: '#FFF!important',
        backgroundColor: `${theme.palette.ddSelector.itemSelected}!important`
    },
    nestedOption: ({ nestingLevel }) => ({
        paddingLeft: theme.spacing(nestingLevel * 2)
    }),
    checkIcon: {
        position: 'absolute',
        fontSize: 18
    },
    title: {
        lineHeight: '1.2',
        paddingLeft: 24
    },
    externalCode: {
        maxWidth: '30%',
        color: theme.palette.externalCodeColor,
        textAlign: 'right',
        wordBreak: 'break-all'
    },
    disabled: {
        cursor: 'not-allowed',
        opacity: 0.6
    }
}));
function SelectElement({ option, handleClick, isSelected, nestingLevel = 0, isSingleSelect, disabled, style = {} }) {
    const classes = useStyles({ nestingLevel });
    const { label, externalCode } = option;
    const clickHandler = (opt) => (event) => {
        if (disabled) {
            stopEventNativeProcessing(event);
            return;
        }
        if (!isSingleSelect) {
            stopEventNativeProcessing(event);
        }
        handleClick(opt, event);
    };
    const stopEventNativeProcessing = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    const classList = useMemo(() => {
        const list = [classes.selectEl];
        if (isSelected) {
            list.push(classes.selectedEl);
        }
        if (nestingLevel) {
            list.push(classes.nestedOption);
        }
        if (disabled) {
            list.push(classes.disabled);
        }
        return list.join(' ');
    }, [disabled, nestingLevel, classes, isSelected]);
    return (React.createElement("div", { style: style, className: classList, onClick: clickHandler(option) },
        isSelected && React.createElement(CheckIcon, { className: classes.checkIcon }),
        React.createElement("div", { className: classNames(classes.title, 'line-clamp-ellipsis-2'), title: label || I18n.t('NoName'), style: { width: externalCode ? '70%' : '100%' } }, label || I18n.t('NoName')),
        externalCode && (React.createElement("div", { className: classNames(classes.externalCode, 'line-clamp-ellipsis'), title: externalCode }, externalCode))));
}
export default SelectElement;
